module.exports = __webpack_public_path__ + "img/SeedIconM.7bf73d43.png";